import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LinkedIn from './icon-linked-in.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LinkedIn {...validProps} />;
}
SvgComponent.iconName = 'linkedIn';

/**
 * @deprecated This is a legacy icon
 */
export const LinkedInIcon = svgIconWrapper(SvgComponent);
